import { Text } from '@mantine/core';
import { ReactNode } from 'react';

const RIGHT_SECTION_MIN_WIDTH = 42;
const RIGHT_SECTION_HORIZONTAL_PADDING = 24;
const RIGHT_SECTION_CHARACTER_WIDTH = 7;

export const getStringRightSectionProps = (
  rightSection: ReactNode,
): { rightSection: ReactNode; rightSectionWidth?: number; rightSectionPointerEvents?: 'none' } => {
  if (typeof rightSection !== 'string') {
    return { rightSection };
  }

  return {
    rightSection: (
      <Text c="dimmed" size="xs" style={{ whiteSpace: 'nowrap' }}>
        {rightSection}
      </Text>
    ),
    rightSectionWidth: Math.max(
      RIGHT_SECTION_MIN_WIDTH,
      rightSection.length * RIGHT_SECTION_CHARACTER_WIDTH + RIGHT_SECTION_HORIZONTAL_PADDING,
    ),
    rightSectionPointerEvents: 'none',
  };
};
